const authActions = {
  CANDIDATE_LOGIN:'CANDIDATE_LOGIN',
  RPT_CANDIDATE_LOGIN:"RPT_CANDIDATE_LOGIN",
  CANDIDATE_USER_LOGIN:'CANDIDATE_USER_LOGIN',
  CANDIDATE_USER_SSO_LOGIN:'CANDIDATE_USER_SSO_LOGIN'
};

export default authActions;
